export default __webpack_public_path__ + "static/media/survey-img.aa8d3fbc.png";